(function($) {

    'use strict';

    function ProductList() {

        var self = this,
            $el = null,
            mapObject = null,
            $btnSwitch = $('[data-btn]'),
            $display = null,
            $displayCtn = $('[data-display]'),
            options = {
                'example': null
            };

        /**
         * Generic resize
         */
        /*function onResize() {
          if (window.bp.getValue() === 'lg' || window.bp.getValue() === 'xl') {
            Utils.setEqualHeight($summaryNews);
          } else {
            Utils.removeEqualHeight($summaryNews);
          }
        }*/

        /**
         * Public constructor
         * @param  {Object} opts Options
         */
        self.initialize = function(opts) {
            //extends options
            for (var i in opts) { options[i] = opts[i];}

            // Caching
            $btnSwitch.on('click', function(){
                $btnSwitch.removeClass('active');
                $(this).addClass('active');

                $display = $(this).attr('data-btn');
                $displayCtn.removeClass('js-hide');
                if($display === "list") {
                    $('[data-display="map"]').addClass('js-hide');
                } else if($display === "map") {
                    $('[data-display="list"]').addClass('js-hide');
                    setTimeout(function() {
                      mapObject.resize();
                    }, 100);
                }

            });


            //------------
            // Products Map
            //-------------
            var stylemap = [{
              "featureType": "administrative",
              "elementType": "labels.text.fill",
              "stylers": [{"color": "#444444"}]
            }, {"featureType": "landscape", "elementType": "all", "stylers": [{"color": "#f2f2f2"}]}, {
              "featureType": "poi",
              "elementType": "all",
              "stylers": [{"visibility": "off"}]
            }, {
              "featureType": "road",
              "elementType": "all",
              "stylers": [{"saturation": -100}, {"lightness": 45}]
            }, {
              "featureType": "road.highway",
              "elementType": "all",
              "stylers": [{"visibility": "simplified"}]
            }, {
              "featureType": "road.arterial",
              "elementType": "labels.icon",
              "stylers": [{"visibility": "off"}]
            }, {"featureType": "transit", "elementType": "all", "stylers": [{"visibility": "off"}]}, {
              "featureType": "water",
              "elementType": "all",
              "stylers": [{"color": "#c0e4f3"}, {"visibility": "on"}]
            }];


            var $map = $('#map-products');
            if ($map.length > 0) {
              var markers = JSON.parse($map.attr('data-markers'));
              // Check if markers is of type array
              if (markers && Object.prototype.toString.call(markers) === '[object Array]') {
                mapObject = new GoogleMap({
                  id: 'map-products',
                  title : 'Trustcan',
                  //zoom: 13,
                  markers: markers,
                  styles: stylemap,
                  infoWindow: {
                    pixelOffset: { x: 0, y: 0 },
                  },
                  //center: new google.maps.LatLng(45.5204959, -73.6367873),
                  icon: {
                    url: $map.attr('data-icon'),
                    width: 31,
                    height: 45,
                  },
                });
              }
            }



            // Filters
            var $wrapper = $('[data-display="list"]');
            var $divs = $wrapper.find(".result");
            $("#select-filter-price").on("change",function(){
                var numericallyOrderedDivs;
                if($(this).val() === "croissant"){
                    numericallyOrderedDivs = $divs.sort(function (a, b) {
                        return parseInt($(a).attr("data-prix")) - parseInt($(b).attr("data-prix"));
                    });
                    $wrapper.html(numericallyOrderedDivs);
                }
                else if($(this).val() === "decroissant"){
                    numericallyOrderedDivs = $divs.sort(function (a, b) {
                        return parseInt($(b).attr("data-prix")) - parseInt($(a).attr("data-prix"));
                    });
                    $wrapper.html(numericallyOrderedDivs);
                }
            });

        };

        self.initialize.apply(self, arguments);
        return self;
    }

    /* Namespace declaration */
    window.ProductList = ProductList;

}(jQuery));
